'use strict';

module.exports = ['$scope', '$location', function ($scope, $location) {

    class ReportDateRangePicker {
        constructor() {

            this.form = $scope.form;
            this.source = $scope.source;

            this.resolutionOptions = [
                ['day', 'Day'],
                ['week', 'Week'],
                ['month', 'Month']
            ];

            this.presets = [
                {name: 'This Week', resolution: "day", range: "this", period: "week"},
                {name: 'Next Week', resolution: "day", range: "next", period: "week"},
                {name: 'Three Weeks', resolution: "day", range: "three", period: "week"},
                {name: 'This Month', resolution: "week", range: "this", period: "month"},
                {name: 'Next Month', resolution: "week", range: "next", period: "month"},
                {name: 'This Quarter', resolution: "month", range: "this", period: "quarter"},
                {name: 'This Year', resolution: "month", range: "this", period: "year"}
            ];

            $scope.$watchCollection('form', function (newVal, oldVal) {

                if (!newVal) return;

                if (newVal.fromInput) {
                    var momentValue = moment(newVal.fromInput, $scope.$root.dateFormat.moment);

                    $scope.reportOptions.from = momentValue.startOf('day').format($scope.$root.dateFormat.moment_url);

                    var toVal = moment($scope.form.toInput, $scope.$root.dateFormat.moment);

                    if (momentValue.isAfter(toVal)) {
                        $scope.form.toInput = moment(momentValue).add(1, 'days').format($scope.$root.dateFormat.moment);
                    }
                }

                if (newVal.toInput) {
                    $scope.reportOptions.to = moment(newVal.toInput, $scope.$root.dateFormat.moment).startOf('day').format($scope.$root.dateFormat.moment_url);
                }
            });
        }

        sourceIs(source_type) {
            return $scope.source && $scope.source.type == source_type;
        }

        getMinDate() {
            var date = "";
            if (this.sourceIs("order_plan")) {
                date = moment({year: $scope.source.year}).startOf("year").format($scope.$root.dateFormat.moment);
            }
            return date;
        }

        getMaxDate() {
            var date = "";
            if (this.sourceIs("order_plan")) {
                date = moment({year: $scope.source.year}).endOf("year").format($scope.$root.dateFormat.moment);
            }
            return date;
        }

        changePreset(preset) {

            var from = moment().startOf(preset.period);
            var to = moment().endOf(preset.period);

            switch (preset.range) {
                case "next":
                    from.add(1, preset.period);
                    to.add(1, preset.period);
                    break;
                case "three":
                    to.add(2, preset.period);
                    break;
            }

            $location.search('from', from.startOf('day').format($scope.$root.dateFormat.moment_url));
            $location.search('to', to.startOf('day').format($scope.$root.dateFormat.moment_url));
            $location.search('resolution', preset.resolution);
        }
    }

    return new ReportDateRangePicker();

}];

